import React from 'react'
import { makeStyles } from '@material-ui/core';
// import PageWrapper from './PageWrapper'

const useStyles = makeStyles(theme => ({
    content: {
        backgroundColor: '#fff',
        boxShadow: '0 -80px 40px rgba(0,0,0,0.05)',
        margin: '0 4rem 4rem',
        marginTop: '-15rem',
        position: 'relative',
        zIndex: '1',
        [theme.breakpoints.down('768')]: {
            padding: '6rem'
        }
    },
}));

export default function PageContent(props) {
    const classes = useStyles();

    return (
        <div className={`page__content ${classes.content}`}>
            {props.children}
        </div>
    )
}